import _ from 'lodash'

const getValueFromTheme = (val: string, colors: Array<string>) => {
	const colorNumber = val && val.split('_')[1]
	return _.get(colors, colorNumber, val)
}

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const getCompStyles = (compStyleKeys: any, styleProperties: any, colors: any) => {
	return _.reduce(
		compStyleKeys,
		(result, value, key) => {
			_.assign(result, { [key]: getValueFromTheme(styleProperties[value], colors) })
			_.assign(result, {
				[`alpha${capitalize(key)}`]: getValueFromTheme(styleProperties[`alpha-${value}`], colors),
			})
			return result
		},
		{}
	)
}

export const getUrl = (baseUrl: string, compId: string, deviceType: string, locale: string) => {
	const viewMode = 'site'
	if (baseUrl.indexOf('https') > -1) {
		return `${baseUrl}?${new URLSearchParams({ compId, deviceType, locale, viewMode })}`
	} else {
		return `${baseUrl.replace('http', 'https')}?${new URLSearchParams({ compId, deviceType, locale, viewMode })}`
	}
}

export { SlideShowGalleryPropertiesSchema } from './SlideShowGalleryProperties.schema'
